import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    // Apply syntax highlighting to all code blocks
    this.highlightCode()
    // Add line numbers to code blocks
    this.addLineNumbers()
    // Add copy buttons to code blocks
    this.addCopyButtons()
  }

  highlightCode() {
    // Find all code blocks (not inline code)
    const codeBlocks = this.element.querySelectorAll('pre code, code:not(p code):not(li code):not(h1 code):not(h2 code):not(h3 code):not(h4 code):not(h5 code):not(h6 code):not(td code):not(th code)')

    codeBlocks.forEach((block) => {
      // 言語クラスが無ければ plaintext を付与（色付けは現状なし。行番号・コピーは下で付与）
      if (!block.className.includes('language-')) {
        block.classList.add('language-plaintext')
      }
    })
  }

  addLineNumbers() {
    const codeBlocks = this.element.querySelectorAll('pre code')

    codeBlocks.forEach((block) => {
      // Skip if line numbers already added
      if (block.querySelector('.line-number')) return

      const lines = block.innerHTML.split('\n')
      // Remove trailing empty line
      if (lines.length > 1 && lines[lines.length - 1].trim() === '') {
        lines.pop()
      }

      block.innerHTML = lines.map((line, i) => {
        return `<span class="line-number">${i + 1}</span>${line}`
      }).join('\n')
    })
  }

  addCopyButtons() {
    // Find all code blocks (both pre > code and standalone code blocks)
    const codeBlocks = this.element.querySelectorAll('pre code, code:not(p code):not(li code):not(h1 code):not(h2 code):not(h3 code):not(h4 code):not(h5 code):not(h6 code):not(td code):not(th code)')

    codeBlocks.forEach((block) => {
      // Get the parent container (pre or code itself)
      const container = block.parentElement.tagName === 'PRE' ? block.parentElement : block

      // Skip if copy button already exists
      if (container.querySelector('.code-copy-button')) return

      // Make container position relative for absolute positioning of button
      container.style.position = 'relative'

      // Create copy button
      const copyButton = document.createElement('button')
      copyButton.className = 'code-copy-button'
      copyButton.type = 'button'
      copyButton.innerHTML = `
        <svg class="copy-icon" width="16" height="16" viewBox="0 0 16 16" fill="currentColor">
          <path d="M4 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V2z"/>
          <path d="M2 6a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2v-1H6a3 3 0 0 1-3-3V6H2z"/>
        </svg>
        <svg class="check-icon hidden" width="16" height="16" viewBox="0 0 16 16" fill="currentColor">
          <path d="M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0z"/>
        </svg>
      `
      copyButton.setAttribute('aria-label', 'Copy code')
      copyButton.addEventListener('click', () => this.copyCode(block, copyButton))

      // Add button to container
      container.appendChild(copyButton)
    })
  }

  async copyCode(codeBlock, button) {
    const code = codeBlock.textContent

    try {
      await navigator.clipboard.writeText(code)

      // Show check icon
      const copyIcon = button.querySelector('.copy-icon')
      const checkIcon = button.querySelector('.check-icon')

      copyIcon.classList.add('hidden')
      checkIcon.classList.remove('hidden')
      button.classList.add('copied')

      // Reset after 2 seconds
      setTimeout(() => {
        copyIcon.classList.remove('hidden')
        checkIcon.classList.add('hidden')
        button.classList.remove('copied')
      }, 2000)
    } catch (err) {
      console.error('Failed to copy code:', err)
    }
  }
}
